import styled from 'styled-components'
import Icon from '@chegg-wt/core/components/Icon'
import { PrimaryButton } from '@chegg/fanta'
import { colors } from '@chegg-ui/theme'
import { Large } from '@chegg-wt/core/theme/fanta/button'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'
import { LargeLink as SunkistLinkLargeLink } from '@chegg-wt/core/theme/sunkist/link'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { Heading2, BodyLarge, BodySmall } from '@chegg-wt/core/theme/sunkist/typography'

// shared styles
export const SubHeader = styled.div`
  ${BodySmall};
  text-transform: uppercase;
`
export const Input = styled.input`
  ${BodyLarge};
  height: 34px;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  border-radius: 8px;
  padding-left: 12px;
`

// containers
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
export const FormContainer = styled.div`
  margin-top: ${values.xsmall};
`
export const PreviewContainer = styled.div``
export const InputContainer = styled.div`
  display: flex;
  margin-bottom: ${values.small};
`
export const CheckboxField = styled.div`
  margin-top: 25px;
`
export const TextField = styled.div`
  width: 100%;
`

export const Header = styled.h3`
  ${Heading2};
  margin-top: 0;
`

export const PreviewContent = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  background-color: ${colors.greyXlight};
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 8px;
`

export const Button = styled(PrimaryButton)`
  ${Large};
  width: 114px;
  padding: 0;
  border-color: ${({ theme }) => theme.Colors.primaryColor};
  background-color: ${({ theme }) => theme.Colors.primaryColor};
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
    background-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
  }
`

export const LargeLink = styled.a`
  ${SunkistLinkLargeLink};
`

export const Chevron = styled(Icon)`
  margin-left: -6px;
  margin-top: 2px;
`

export const FootnoteErrorContainer = styled.div`
  margin-top: ${FantaTheme.spacing.fanta.md};
  margin-bottom: ${FantaTheme.spacing.fanta.md};
`
export const FootnoteErrorText = styled.span`
  color: ${FantaTheme.colors.errorRed};
`
